var module = angular.module('octopusApp.certificates');

module.controller('CertificateReplaceDialogController', function ($scope, certificate, $uibModalInstance, octopusRepository, busy) {

    $scope.isWorking = busy.create();

    $scope.newCertificate = {
        certificateData: { HasValue: false, NewValue: null},
        password: { HasValue: false, NewValue: null}
    };

    $scope.replace = function() {
        $scope.isWorking.promise(
            octopusRepository.Certificates.replace(certificate, $scope.newCertificate.certificateData.NewValue, $scope.newCertificate.password.NewValue)
            .then(function(replaced){
                $uibModalInstance.close(replaced);
            }));
    };

    $scope.close = function () {
        $uibModalInstance.close();
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/details/certificate_replace_dialog_controller.js
// module id = 6927460449193229
// module chunks = 1